import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '../pages/HomePage.vue'
import LiteraturePage from '../pages/LiteraturePage.vue'
import InfoPage from '../pages/InfoPage.vue'
import TasksPage from '../pages/TasksPage.vue'
import TeamRegistration from '../pages/TeamRegistration.vue'
import AdminPage from '../pages/AdminPage.vue'
import FormCreatePage from '../pages/FormCreatePage.vue'
import FormsChoosePage from '../pages/FormsChoosePage.vue'
import { checkLogin } from '../services/userServices'
import { checkAdmin } from '../services/adminServices'
import FormPage from '../pages/FormPage.vue'
import ForgotPassword from '../pages/ForgotPassword.vue'
import ResetPassword from '../pages/ResetPassword.vue'
import SetTeamPassword from '../pages/SetTeamPassword.vue'
import { activateUserService } from '../services/userServices'
import { isFillableForm, checkIsDone } from '../services/formServices'


const  beforeEnter = async () => {
  return (await checkLogin()) ? true : {name: 'home'} 
}

const beforeCompetition = async (route) => {
  const isLoggedIn = await beforeEnter()
  if(isLoggedIn !== true) {
    return isLoggedIn
  }
  const { results } = await checkIsDone(route.params.competitionId)
  if(results) {
    return {name: 'competitions'}
  }
  const isFillable = await isFillableForm(route.params.competitionId)
  return isFillable ? true : {name: 'competitions'}
}

const  beforeEnterAdmin = async () => {
  return (await checkAdmin()) ? true : {name: 'home'} 
}

const activateUser = async (route) => {
  const queryParams = route.params.userId
  await activateUserService(queryParams)
  return { name: 'home', query: { activation: !!(await activateUserService(queryParams)) } }
}

const routes = [
  { path: '/:catchAll(.*)*', redirect: '/' },
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  { path: '/admin/form/:competitionId', name: 'admin-form', component: FormCreatePage, props: true, beforeEnter: beforeEnterAdmin},
  { path: '/tasks/:competitionId', name: 'tasks', component: TasksPage, beforeEnter: beforeCompetition},
  { path: '/team/:competitionId', name: 'team', component: TeamRegistration, beforeEnter },
  { path: '/literature', name: 'literature', component: LiteraturePage, beforeEnter },
  { path: '/info', name: 'info', component: InfoPage },
  { path: '/admin', name: 'admin', component: AdminPage, beforeEnter: beforeEnterAdmin },
  { path: '/competitions', name: 'competitions', component: FormsChoosePage, beforeEnter},
  { path: '/activate/:userId', name: 'activate-user', beforeEnter: activateUser },
  { path: '/forms/:competitionId', name: 'forms', component: FormPage },
  { path: '/reset-password', name: 'reset-pw', component: ForgotPassword },
  { path: '/new-password/:token', name: 'new-pw', component: ResetPassword },
  { path: '/set-password', name: 'set-pw', component: SetTeamPassword, beforeEnter },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})
